import { AlertCircle, CheckCircle, EyeOff, LinkBroken02, Type01, UserX01, VideoRecorderOff } from "@untitledui/icons";
import type { FC } from "react";
import type { SafetyPolicy } from "@/api/safety-policies";

// Display copy for the predefined safety policies shown in the Policies tab.
// The DB has no name/description columns, so this is the single source of truth
// for the human-facing wording here. Keyed by the `safety_policies.type` enum so
// adding a new policy type is a compile error until its copy is filled in.
export type PolicyType = SafetyPolicy["type"];

export const POLICY_NAMES: Record<PolicyType, string> = {
  end_creator_relationship: "End creator relationship",
  end_linked_collaboration: "End linked collaboration",
  request_video_removal: "Request video removal",
  request_metadata_edit: "Request metadata edit",
  warn_and_remove_from_gmv_max: "Send warning to creator and remove from GMV Max",
  warn_creator: "Send warning to creator",
  remove_from_gmv_max_only: "Remove from GMV Max only",
  no_action_needed: "No Action needed",
};

export const POLICY_DESCRIPTIONS: Record<PolicyType, string> = {
  end_creator_relationship:
    "For the most serious violations. Severs the creator relationship completely with a final takedown notice.",
  end_linked_collaboration: "Ends this collab and removes the video. Creator stays.",
  request_video_removal: "Asks creator to remove the video. Protects ads while waiting.",
  request_metadata_edit: "Asks creator to fix hashtags or metadata. Protects ads.",
  warn_and_remove_from_gmv_max: "Warns the creator and pulls the video from GMV Max campaigns.",
  warn_creator: "Notifies creator, logs the warning, no enforcement.",
  remove_from_gmv_max_only: "Pulls the video from GMV Max campaigns. No creator message.",
  no_action_needed: "No action taken. Risk marked as resolved.",
};

// Icon shown next to each policy's name + description in the Policies table.
export const POLICY_ICONS: Record<PolicyType, FC<{ className?: string }>> = {
  end_creator_relationship: UserX01,
  end_linked_collaboration: LinkBroken02,
  request_video_removal: VideoRecorderOff,
  request_metadata_edit: Type01,
  warn_and_remove_from_gmv_max: AlertCircle,
  warn_creator: AlertCircle,
  remove_from_gmv_max_only: EyeOff,
  no_action_needed: CheckCircle,
};
